import { any, func } from "prop-types";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import {
  faBold,
  faEraser,
  faItalic,
  faLink,
  faLinkSlash,
  faList,
  faUnderline,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components/macro";
import { rem } from "polished";

/**
 * WYSIWYG Menu
 */
function WysiwygMenu({ editor, onOpenLinkModal }) {
  return (
    <Toolbar>
      <button
        onClick={() => {
          editor.chain().focus().unsetAllMarks().run();
          editor.chain().focus().clearNodes().run();
        }}
        type="button"
      >
        <Icon icon={faEraser} className="editor-icon" />
      </button>

      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={editor.isActive("bulletList") ? "is-active" : ""}
        type="button"
      >
        <Icon icon={faList} className="editor-icon" />
      </button>

      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={editor.isActive("bold") ? "is-active" : ""}
        type="button"
      >
        <Icon icon={faBold} className="editor-icon" />
      </button>

      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={editor.isActive("italic") ? "is-active" : ""}
        type="button"
      >
        <Icon icon={faItalic} className="editor-icon" />
      </button>

      <button
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        disabled={!editor.can().chain().focus().toggleUnderline().run()}
        className={editor.isActive("underline") ? "is-active" : ""}
        type="button"
      >
        <Icon icon={faUnderline} className="editor-icon" />
      </button>

      <button
        onClick={onOpenLinkModal}
        className={editor.isActive("link") ? "is-active" : ""}
        type="button"
      >
        <Icon icon={faLink} className="editor-icon" />
      </button>

      <button
        onClick={() => editor.chain().focus().unsetLink().run()}
        disabled={!editor.can().chain().focus().unsetLink().run()}
        type="button"
      >
        <Icon icon={faLinkSlash} className="editor-icon" />
      </button>
    </Toolbar>
  );
}

WysiwygMenu.propTypes = {
  editor: any.isRequired,
  onOpenLinkModal: func.isRequired,
};

const Toolbar = styled.div`
  border: 0 none;
  border-bottom: ${rem("1px")} solid
    ${({ theme }) => theme.text.wysiwygToolbarBorderColor};
  border-radius: ${rem("5px")} ${rem("5px")} 0 0;
  padding: ${rem("8px")};
  position: relative;

  button {
    background: transparent;
    border: dotted 0.0625rem transparent;
    cursor: pointer;
    height: ${rem("24px")};
    padding: ${rem("3px")} ${rem("5px")};
    min-width: ${rem("28px")};

    &:focus {
      border: dotted 0.0625rem #fff;
      border-radius: ${rem("5px")};
      outline: none;

      .editor-icon {
        path {
          fill: ${({ theme }) => theme.text.wysiwygToolbarColorHover};
        }
      }
    }

    .editor-icon {
      path {
        fill: ${({ theme }) => theme.text.wysiwygToolbarColor};
      }
    }

    &:hover,
    &.is-active {
      .editor-icon {
        path {
          fill: ${({ theme }) => theme.text.wysiwygToolbarColorHover};
        }
      }
    }
  }
`;

export default WysiwygMenu;
